import { render, staticRenderFns } from "./indexx.vue?vue&type=template&id=6b0e0104&scoped=true&"
import script from "./indexx.vue?vue&type=script&lang=js&"
export * from "./indexx.vue?vue&type=script&lang=js&"
import style0 from "./indexx.vue?vue&type=style&index=0&id=6b0e0104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e0104",
  null
  
)

export default component.exports